import { useState, useEffect } from 'react';

import { parse } from 'qs';

import { Trip } from 'src/types';

import superagent from 'superagent';

type Response = {
  body: {
    error: Record<string, string> | null;
    result: {
      order: {
        product: 'hotels' | 'avia';
        rentInfo?: {
          hotel: string;
          departureDate: Date;
          arrivalDate: Date;
        };
        trips?: Trip[];
      };
    } | null;
  };
};

const useOrdersServiceSharingInfo = (): {
  isLoading: boolean;
  result: Response['body']['result'];
} => {
  const [result, setResult] = useState<Response['body']['result']>(null);
  const [isLoading, setIsLoading] = useState(true);

  const search = typeof window !== 'undefined' ? window.location.search : '';
  const sharingCode = parse(search, { ignoreQueryPrefix: true }).code || '';
  const query = sharingCode ? { code: sharingCode } : {};

  useEffect(() => {
    if (query.code) {
      superagent
        .get('/_orders_service/sharing/info/')
        .query(query)
        .then((response: Response): void => {
          const { result } = response.body;

          if (result?.order) {
            setResult(result);
          }
        })
        .catch((error) => console.error(error.toString()))
        .finally(() => {
          setTimeout(() => {
            setIsLoading(false);
          }, 2500);
        });
    } else {
      setTimeout(() => {
        setIsLoading(false);
      }, 3000);
    }
  }, []);

  return { isLoading, result };
};

export default useOrdersServiceSharingInfo;
